
import config from '../../config';


// export const MOJE_LAHVE_URL = "https://jzyt.mojelahve.cz";
// export const EVO_URL = "https://ts.vinarskyobzor.cz";
// export const EVO_URL = "https://testing.vinarskyobzor.cz";
export const EVO_URL = "https://ij.vinarskyobzor.cz";
// export const EVO_URL = "https://vinarskyobzor.cz";
export const EVO_URL_TESTING = "https://testing.vinarskyobzor.cz";
export const EVO_URL_PRODUCTION = "https://vinarskyobzor.cz";


abstract class IEnvironment {
    abstract getEvoUrl(): string;
}

class EnvironmentEvo extends IEnvironment {
    private static instance: EnvironmentEvo;
    private evoUrl: string;

    // Private constructor that takes the environment as a parameter
    private constructor(env: 'development' | 'testing' | 'production') {
        super();
        this.evoUrl = config[env].EVO_URL;
    }

    // Static method to create or return the existing instance
    public static getInstance(env: 'development' | 'testing' | 'production'): EnvironmentEvo {
        if (!EnvironmentEvo.instance) {
            EnvironmentEvo.instance = new EnvironmentEvo(env);
        }
        return EnvironmentEvo.instance;
    }

    // Method to retrieve the EVO URL
    public getEvoUrl(): string {
        return this.evoUrl;
    }
}

export default EnvironmentEvo;